<div class="container-fluid navbar d-flex align-items-center">
    <div>
        <img class="navbar-logo pointer" src="../../../../assets/images/phd-logo.png" alt="Logo" routerLink="/canvas">
    </div>

    <div>
        <div *ngIf="!userLoggedIn">
            <button routerLink="/account/register" class="btn px-2">Register</button>
            <button routerLink="/account/login" class="btn px-2">Login</button>
        </div>
        
        <div *ngIf="userLoggedIn">
            <div ngbDropdown class="d-inline-block" display="dynamic" placement="bottom-end">
            <button type="button" class="btn btn-outline-secondary borderless" id="dropdown" ngbDropdownToggle>
                    <i class="fa-solid fa-user"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdown">
                    <span ngbDropdownItem *ngIf="user">
                        {{user.lastName}},
                        {{user.firstName}}
                    </span>
                    <div class="dropdown-divider"></div>
                    <button ngbDropdownItem routerLink="/canvas" class="btn d-flex">Canvas</button>

                    <button ngbDropdownItem class="btn d-flex align-items-center" (click)="logout()">
                        Logout <i class="fa-solid fa-right-from-bracket ps-3"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>